const emailOptOutStyles = (theme) => {
  return {
    gridOccupy: {
      width: '100%',
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
      paddingTop: theme.spacing(1),
    },
    emailTextContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    horizontalLine: {
      borderBottom: '1px solid gainsboro',
      height: 1,
      width: '94%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    radioForm: {
      alignSelf: 'flex-start',
      marginLeft: theme.spacing(1),
    },
    submitBtn: {
      width: theme.spacing(15),
      padding: theme.spacing(0.5),
      margin: theme.spacing(1),
      backgroundColor: '#90103B',
      color: '#fff',
      textTransform: 'capitalize',
      '&:hover': {
        backgroundColor: '#00acc1',
      },
    },
  };
};

export default emailOptOutStyles;
